import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-heading font-bold text-brand-accent mb-4">404</h1>
        <h2 className="text-2xl font-heading font-semibold text-neutral-light mb-4">
          {t('common.notFound') || 'Page Not Found'}
        </h2>
        <p className="text-neutral-medium mb-8">
          {t('common.notFoundDescription') || 'The page you are looking for does not exist.'}
        </p>
        <Link
          to="/admin/dashboard"
          className="inline-block px-6 py-3 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:bg-brand-accent/90 transition-colors duration-200"
        >
          {t('common.goHome') || 'Go to Dashboard'}
        </Link>
      </div>
    </div>
  );
}

